import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

// Create the context
export const SelectedOffersContext = createContext();

// Create a provider component
export const SelectedOffersProvider = ({ children }) => {
  const [selectedItems, setSelectedItems] = useState([]);

  const createUniqueKey = item => `${item.type}_${item.SKU}_${item.Description}`;

  const addItem = (item) => {
    const uniqueKey = createUniqueKey(item);
    setSelectedItems((prevItems) => {
      if (prevItems.some(i => createUniqueKey(i) === uniqueKey)) return prevItems;
      return [...prevItems, item];
    });
  };

  const removeItem = (uniqueKey) => {
    setSelectedItems(prevItems =>
      prevItems.filter(item => createUniqueKey(item) !== uniqueKey));
  };

  const updateItem = (uniqueKey, updates) => {
    setSelectedItems(prevItems =>
      prevItems.map(item =>
        (createUniqueKey(item) === uniqueKey ? { ...item, ...updates } : item)));
  };

  const clearAllItems = () => {
    setSelectedItems([]);
  };

  return (
    <SelectedOffersContext.Provider
      value={{
        selectedItems,
        addItem,
        removeItem,
        updateItem,
        clearAllItems,
      }}
    >
      {children}
    </SelectedOffersContext.Provider>
  );
};

SelectedOffersProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
